import { auth } from '../en/auth/index';
import { administration } from '../en/administration/index';
import { tests } from '../en/tests/index';
import { homes } from '../en/homes/index';
import { users } from '../en/users/index';
import { dashboard } from '../en/dashboard';
import { training } from '../en/training/index';
import { reports } from '../en/reports/index';

// Messages for EN language
const strings = {
    appName: 'Watt Analytics',
    loading: 'Loading...',
    language: {
        sk: 'Slovak',
        en: 'English',
        de: 'German',
        zh: '中文'
    },
    ok: 'OK',
    add: 'Add',
    permissionsIsAdminTag: 'Administrator',
    permissionsIsNotAdminTag: 'User',
    permissionsIsTesterTag: 'Tester',
    permissionsIsInstallerTag: 'Installer',
    select: 'Select',
    save: 'Save',
    download: 'Download',
    close: 'Close',
    cancel: 'Cancel',
    version: 'Version',
    reload: 'Reload',
    edit: 'Edit',
    invite: 'Invite',
    adminAddUser: 'Add new owner',
    delete: 'Delete',
    undelete: 'Undelete',
    sureToUndeleteTitle: 'Are you sure you want to undelete this record?',
    sureToDeleteTitle: 'Are you sure you want to delete this record?',
    maxLengthReached: 'Max length reached.',
    actionsLabel: 'Actions',
    logoutLink: 'Log out',
    dashboardRoute: 'Dashboard',
    noDataAvailable: 'No data',
    requiredField: 'This field is required',
    emailFormatField: 'Email address do not have correct format.',
    msgErrorApi: 'Error while fetching data from API',
    perMinute: 'per min.',
    id: 'ID',
    auth,
    administration,
    tests,
    homes,
    users,
    dashboard,
    training,
    reports
};

export default strings;
